import { getCurrentDateWithDay } from "@/helpers/format-date";
import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { findDailyForecastById } from "@/helpers/daily-forecast-helpers";
import { formatWeatherStateIcon } from "@/helpers/format-weather-state-icon";

import WeatherWithIcon from "@/components/weather-with-icon/WeatherWithIcon";

import "./style.scss";

export const WeatherTableHeader = () => {
	const { date, day } = getCurrentDateWithDay();

	const { dayliesData } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) =>
			select(WEATHER_STORE).getDailyForecast(),
		[],
	);

	const findDailyForecast = findDailyForecastById("40581", dayliesData);

	const currentDay = findDailyForecast.find(
		(item) => new Date(item.date).getDate() === new Date().getDate(),
	);

	const weatherIcon = currentDay?.date
		? formatWeatherStateIcon({
				timeStep: currentDay?.date.toISOString(),
				status: currentDay?.ww,
		  })
		: undefined;

	return (
		<div className="weather-table-header">
			<div className="date">
				<p>{day}</p>
				<p>{date}</p>
			</div>

			<WeatherWithIcon
				type="weather"
				tempMax={currentDay?.temperature_max ?? "-"}
				tempMin={currentDay?.temperature_min ?? "-"}
				icon={
					weatherIcon ? (
						<img
							className="icon-weather"
							src={weatherIcon}
							alt="weather icon"
						/>
					) : undefined
				}
			/>
		</div>
	);
};

export default WeatherTableHeader;
